/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { PriceHandler } from '../../../../redux/helper/CamelCase';
import { CDN } from '../../../../constants';

function DirectOrderSummary({
    OrderDetails,
    type,
    handleCreatePopup,
}) {
    const { orderId, distributorId } = useParams();
    function quantityCheck() {
        for (const element in OrderDetails.items) {
            for (const item of OrderDetails.items[element]) {
                if (Number(item.quantity) <= 0) {
                    return false; // Exit the function when the condition is met
                }
            }
        }
        return true;
    }
    return (
        <div className="lg:w-[30%] w-full mx-5  mt-3 ">
            <div className="border border-[#CBC7C7] px-4 pt-[18px] rounded-md bg-[#F5F5FA] pb-4">
                {type !== 'placeOrder' && (
                    <div className="relative pb-3.5">
                        <img style={{ borderRadius: '50%', objectFit: 'cover' }} src={OrderDetails?.distributor_info?.profile_image_url !== '' && OrderDetails?.distributor_info?.profile_image_url !== undefined ? (`${CDN}/${OrderDetails?.distributor_info?.profile_image_url}`) : '/images/pp.svg'} className="cursor-pointer w-[50px] h-[50px]" alt="icon" />
                        <p className="absolute text-sm28 font-semibold top-[0px] left-[70px]">
                            {' '}
                            {OrderDetails?.distributor_info?.PARTY_NAME}
                        </p>
                        <p className="absolute text-sm29 text-[#555259] font-normal top-[50px] left-[70px]">
                            {' '}
                            {distributorId}
                            {' '}
                        </p>
                    </div>
                )}
                <div className="border-b border-[#CBCBCB] pb-2.5">
                    <div className="flex justify-between items-center">
                        <p className="text-sm font-semibold text-[#090406]">Order Type</p>
                        <p className="font-normal text-sm text-[#555259]">
                            {OrderDetails?.summary?.quantity && Object.keys(OrderDetails?.summary?.quantity).length > 0 && Object.keys(OrderDetails?.summary?.quantity).map((UOM, i) => (
                                <span style={{ float: `${i === 0 ? '' : 'right'}` }} key={UOM} className="font-semibold">
                                    {Number(OrderDetails?.summary?.quantity[UOM])}
                                    {' '}
                                    {UOM}
                                    {' '}
                                    <br />
                                </span>
                            ))}

                        </p>
                    </div>
                    <p className="sm:text-lg text-base font-normal text-[#555259]">
                        {OrderDetails?.order_type }
                        {' '}
                        Order
                    </p>
                </div>
                <div className="pt-1.5">
                    <div>
                        <p className="sm:text-lg text-base font-semibold text-[#090406]">Order Summary</p>
                        <div className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">
                                    {PriceHandler(OrderDetails?.summary?.order_value)}
                                    {' '}
                                </p>
                            </div>
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Discount</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.total_discount)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Sub Total</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.summary?.sub_total)}</p>
                            </div>
                        </div>
                        <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                            <div className="flex justify-between items-center sm:mt-0 mt-1">
                                <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST (18%)</p>
                                <p className="sm:text-lg text-base font-semibold text-[#555259]">{PriceHandler(OrderDetails?.summary?.order_gst.gst)}</p>
                            </div>
                        </div>
                        <div className="sm:pr-1 sm:pl-2 border-b border-[#CBCBCB] py-1">
                            <div className="flex justify-between items-center mt-1.5">
                                <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                                <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{PriceHandler(OrderDetails?.summary?.order_gross_amount)}</p>
                            </div>
                        </div>
                    </div>
                    <p className="font-normal text-[#FF3B30] text-xs13 mt-3">*Taxes & Duties are subject to change as per Government guidelines and will be charged as applicable at the time of dispatch</p>
                </div>
                <div className="mt-3.5">
                    {type !== 'placeOrder' ? (
                        quantityCheck() === true
                            ? (
                                <Link to={`/manage-orders/direct-order/${distributorId}/${orderId}/edit/order-details`}>
                                    <a href="javascript:void(0)">
                                        {' '}
                                        <button type="button" className="w-full py-2 rounded-lg sm:text-lg text-base font-semibold text-[#FFFFFF] bg-[#555259]" data-bs-toggle="modal" data-bs-target="#orderPlaced">
                                            Add Order Details
                                        </button>
                                    </a>
                                </Link>
                            ) : (
                                <button type="button" disabled className={`w-full py-2 rounded-lg sm:text-lg text-base font-semibold ${OrderDetails?.summary?.order_gross_amount > 0 ? 'bg-[#555259] text-[#FFFFFF] ' : 'bg-[#cfcece] border border-[#808285] text-[#555259] '}`} data-bs-toggle="modal" data-bs-target="#orderPlaced">
                                    Add Order Details
                                </button>
                            )
                    )
                        : (
                            <a href="javascript:void(0)">
                                {' '}
                                <button type="button" className="w-full py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" onClick={handleCreatePopup} data-bs-toggle="modal" data-bs-target="#orderPlaced">
                                    Place Order
                                </button>
                            </a>
                        )}
                </div>
            </div>
            { OrderDetails?.work_flow_status ? Number(OrderDetails.work_flow_status) > 0 && (
                <div className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
                    <p className="text-[#090406] font-semibold text-base mt-3">Ador Comments</p>
                    {OrderDetails?.approvals.approval.map((item) => (
                        <p className="font-normal text-sm text-[#555259]">
                            <b>{item.role_name}</b>
                            {' '}
                            -
                            {' '}
                            {item.note}
                        </p>

                    ))}
                </div>
            ) : null }
        </div>
    );
}

export default DirectOrderSummary;
